module.exports = __webpack_public_path__ + "img/vip1.a110e833.jpg";